import { get, post, put } from '@aiptyg/api-client';
import { query, type Page } from './service';

export interface FinanceAccount {
  agent_id: number; agent_name: string; currency: string;
  available_minor: number; frozen_minor: number; total_minor: number;
  version: number; updated_at: string;
}
export interface FinanceEntry {
  id: number; agent_id: number; agent_name: string; portal_task_id?: number;
  kind: 'recharge' | 'deduct' | 'freeze' | 'release' | 'settlement';
  amount_minor: number; available_delta_minor: number; frozen_delta_minor: number;
  available_after_minor: number; frozen_after_minor: number;
  reason: string; reference: string; receipt_url?: string; actor_kind: string; actor_id?: number; created_at: string;
}
export interface FinanceTask {
  portal_task_id: number; agent_id: number; agent_name: string; title: string;
  version: number; status: 'not_frozen' | 'frozen' | 'released' | 'settled'; task_status: string;
  unit_amount_minor: number; quota: number; budget_minor: number; frozen_minor: number;
  valid_count: number; charge_minor: number; release_minor: number;
  in_flight_count: number; pending_review_count: number;
  can_settle: boolean; block_reason: string; preview_token: string;
  settlement_mode: 'manual' | 'auto' | ''; settled_at?: string; created_at: string; updated_at: string;
}
export interface FinanceSettings { auto_settle: boolean; version: number; updated_at: string }
export interface BalanceChangeInput {
  amount_minor: number; reason: string; reference?: string; receipt_url?: string;
  portal_task_id?: number; idempotency_key: string;
}
const base = '/v1/admin/agent-finance';
type Filters = Record<string, string | number | undefined>;
export const listFinanceAccounts = (filters: Filters) => get<Page<FinanceAccount>>(`${base}/accounts?${query(filters)}`);
export const getFinanceAccount = (id: number) => get<FinanceAccount>(`${base}/accounts/${id}`);
export const changeFinanceBalance = (id: number, kind: 'recharge' | 'deduct', input: BalanceChangeInput) => post<{ account: FinanceAccount; entry: FinanceEntry }>(`${base}/accounts/${id}/${kind}`, { ...input });
export const listFinanceLedger = (filters: Filters) => get<Page<FinanceEntry>>(`${base}/ledger?${query(filters)}`);
export const listFinanceTasks = (filters: Filters) => get<Page<FinanceTask>>(`${base}/tasks?${query(filters)}`);
export const getFinanceTask = (id: number) => get<FinanceTask>(`${base}/tasks/${id}`);
export const settleFinanceTask = (task: FinanceTask, key: string) => post<FinanceTask>(`${base}/tasks/${task.portal_task_id}/settle`, { expected_version: task.version, preview_token: task.preview_token, idempotency_key: key });
export const getFinanceSettings = () => get<FinanceSettings>(`${base}/settings`);
export const saveFinanceSettings = (settings: FinanceSettings, auto_settle: boolean) => put<FinanceSettings>(`${base}/settings`, { auto_settle, expected_version: settings.version });
